import React from 'react';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { Container } from './styles';

const RoomQuantityTooltip = ({
  children
}) => {

  return (
    <>
      <style>
        {`
          .rc-tooltip-placement-right > .rc-tooltip-arrow,
          .rc-tooltip-placement-left > .rc-tooltip-arrow {
            top: calc(50% - 9px) !important;  
          }
          .rc-tooltip-placement-right > .rc-tooltip-arrow::before,
          .rc-tooltip-placement-left > .rc-tooltip-arrow::before {
            top: -16px;
          } 
        `}
      </style>
      <Tooltip
        placement="right"
        trigger={['hover']}
        overlay={
          <Container>
            <div className="tooltip-text">Please select room type first.</div>
          </Container>
        }
      >
        {children}
      </Tooltip>
    </>
  );
}

export default RoomQuantityTooltip;
